import type { FC, ReactNode } from 'react'
import type { ToolSummary } from '@/types'

interface RankingStatsProps {
    tools: ToolSummary[]
}

export const RankingStats: FC<RankingStatsProps> = ({ tools }): ReactNode => {
    const free = tools.filter(tool => tool.is_free).length
    const open = tools.filter(tool => tool.is_open_source).length

    const items = [
        { label: tools.length === 1 ? 'tool ranked' : 'tools ranked', value: tools.length },
        { label: 'with a free plan', value: free },
        { label: 'open source', value: open }
    ]

    return (
        <ul className='flex flex-wrap gap-2'>
            {items.map(item => (
                <li key={item.label} className='inline-flex items-baseline gap-1.5 rounded-full border border-border bg-card/70 px-3.5 py-1.5 text-sm text-muted-foreground'>
                    <span className='font-mono font-semibold tabular-nums text-foreground'>{item.value}</span>
                    {item.label}
                </li>
            ))}
        </ul>
    )
}
